import { render } from "./Tier.vue?vue&type=template&id=f0fe4f8a&scoped=true"
import script from "./Tier.vue?vue&type=script&lang=js"
export * from "./Tier.vue?vue&type=script&lang=js"

import "./Tier.vue?vue&type=style&index=0&id=f0fe4f8a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0fe4f8a"]])

export default __exports__